/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    name: 'EHS_module',
    icon: 'FolderIcon',
    i18n: 'EHS',
    use_name: false,
    title: 'EHS',
    label: 'EHS',
    can: ['IU EHS VIEW', 'IU EHS CATALOG VIEW'],
    submenu: [
      {
        name: 'Dashboard',

        icon: 'PieChartIcon',
        i18n: 'dashboard',
        url: '/ehs/dashboard',
        use_name: false,
        label: 'Dashboard',
        can: ['IU EHS VIEW']
        //subIconCircle:true
      },
      {
        name: 'Gantt Graph',
        tagColor: 'success',
        icon: 'CalendarIcon',
        i18n: 'annual_plan',
        url: '/gantt/annual_plan',
        use_name: false,
        label: 'Gantt',
        can: ['IU EHS VIEW']
      },
      {
        name: 'EHS',
        tagColor: 'success',
        icon: 'ListIcon',
        i18n: 'EHS',
        url: '/ehs',
        use_name: false,
        label: 'EHS',
        can: ['IU EHS VIEW']
      },
      {
        name: 'ehs_catalog',
        icon: 'BookIcon',
        i18n: 'ehs_catalog',
        url: '/ehs_catalog',
        use_name: false,
        label: 'Catalog',
        can: ['IU EHS CATALOG VIEW']
      }
    ]
  },
  {
    name: 'compliance',
    icon: 'ArchiveIcon',
    i18n: 'compliance_sidemenu',
    use_name: false,
    title: 'Compliance',
    label: 'Compliance',
    can: ['IU COMPLIANCE VIEW'],
    submenu: [
      {
        name: 'Dashboard',

        icon: 'PieChartIcon',
        i18n: 'dashboard',
        url: '/compliance/dashboard',
        use_name: false,
        label: 'Dashboard',
        can: ['IU COMPLIANCE VIEW']
      },
      {
        name: 'Compliance',
        tagColor: 'success',
        icon: 'ListIcon',
        i18n: 'compliance_sidemenu',
        url: '/compliance',
        use_name: false,
        label: 'Compliance',
        can: ['IU COMPLIANCE VIEW']
      }
    ]
  },
  {
    name: 'contralor',
    icon: 'DollarSignIcon',
    i18n: 'contralor',
    use_name: false,
    title: 'Contralor',
    label: 'Contralor',
    can: ['IU CONTRALOR VIEW'],
    submenu: [
      {
        name: 'Contralor',
        icon: 'ListIcon',
        i18n: 'contralor',
        url: '/contralor',
        use_name: false,
        label: 'Contralor',
        can: ['IU CONTRALOR VIEW']
      },
      {
        name: 'Contralor Report',
        icon: 'FileTextIcon',
        i18n: 'sidebar_contralor_report',
        url: '/contralor/report',
        use_name: false,
        label: 'Contralor Report',
        can: ['IU CONTRALOR VIEW']
        //subIconCircle:true
      },
      {
        name: 'Contralor Config',
        icon: 'SettingsIcon',
        i18n: 'sidebar_contralor_config',
        url: '/contralor/config',
        use_name: false,
        label: 'Contralor Config',
        can: ['IU asdasdasd VIEW']
      }
    ]
  },
  {
    name: 'accounting',
    icon: 'BarChartIcon',
    i18n: 'accounting',
    use_name: false,
    title: 'Accounting',
    label: 'Accounting',
    can: [
      'IU ACCOUNTING VIEW',
      'IU TAX RETURN VIEW',
      'IU BANK STATEMENT VIEW',
      'IU BLACKLIST VIEW',
      'IU CASH REQUEST VIEW',
      'IU BONUS VIEW',
      'IU BONUS EDIT'
    ],
    submenu: [
      {
        name: 'Accounting',
        icon: 'BarChartIcon',
        i18n: 'dashboard',
        url: '/accounting',
        use_name: false,
        label: 'accounting',
        can: ['IU ACCOUNTING VIEW']
        //subIconCircle:true
      },
      {
        name: 'expenses',
        icon: 'SearchIcon',
        i18n: 'expenses',
        url: '/expenses',
        use_name: false,
        label: 'expenses',
        can: ['IU ACCOUNTING VIEW']
        //subIconCircle:true
      },
      {
        name: 'Iva Return',
        icon: 'CornerDownLeftIcon',
        i18n: 'tax_return',
        url: '/tax_return',
        use_name: false,
        label: 'tax_return',
        can: ['IU TAX RETURN VIEW']
      },
      {
        name: 'Bank Statements',
        icon: 'BookOpenIcon',
        i18n: 'bank_statements',
        url: '/bank_statements',
        use_name: false,
        label: 'bank_statements',
        can: ['IU BANK STATEMENT VIEW']
      },
      {
        name: 'Bank Accounts',
        icon: 'ListIcon',
        i18n: 'bank_accounts',
        url: '/bank_accounts',
        use_name: false,
        label: 'bank_accounts',
        can: ['IU BANK ACCOUNT VIEW']
      },
      {
        name: 'Blacklist',
        icon: 'AlertCircleIcon',
        i18n: 'blacklist',
        url: '/blacklist',
        use_name: false,
        label: 'blacklist',
        can: ['IU BLACKLIST VIEW']
      },
      {
        name: 'BiReport',
        icon: 'BarChart2Icon',
        i18n: 'bi_report',
        url: '/bi_report',
        use_name: false,
        label: 'bi_report',
        can: ['IU ACCOUNTING VIEW']
      },
      {
        name: 'CashRequest',
        icon: 'DollarSignIcon',
        i18n: 'cash_request',
        url: '/cash_request',
        use_name: false,
        label: 'cash_request',
        can: ['IU CASH REQUEST VIEW']
      },
      {
        name: 'Whitelist',
        icon: 'UserPlusIcon',
        i18n: 'Whitelist',
        url: '/expense/automatic',
        use_name: false,
        label: 'Whitelist',
        can: ['IU EXPENSE AUTO']
      },
      {
        name: 'Payroll',
        icon: 'UserCheckIcon',
        i18n: 'payroll',
        url: '/payroll',
        use_name: false,
        label: 'payroll',
        can: ['IU PAYROLL VIEW']
      },
      {
        name: 'bonus',
        icon: 'StarIcon',
        i18n: 'bonus',
        url: '/bonus/home',
        use_name: false,
        label: 'bonus',
        can: ['IU BONUS VIEW'],
      },
      {
        name: 'Recipients',
        icon: 'ListIcon',
        i18n: 'recipients',
        url: '/recipients',
        use_name: false,
        label: 'recipients',
        can: ['IU RECIPIENT VIEW']
      }
    ]
  },

  {
    name: 'import_export',
    icon: 'TruckIcon',
    i18n: 'import_export',
    use_name: false,
    title: 'import_export',
    label: 'import_export',
    can: ['IU ENTRY VIEW', 'IU REVIEW ORDER VIEW', 'IU LOAD ORDER VIEW', 'IU DISCREPANCY VIEW'],
    submenu: [
      {
        name: 'entries',
        icon: 'PrinterIcon',
        i18n: 'sidebar_entries',
        url: '/entries',
        use_name: false,
        label: 'entries',
        can: ['IU ENTRY VIEW']
      },
      {
        name: 'review_order',
        icon: 'ClipboardIcon',
        i18n: 'sidebar_review_orders',
        url: '/review_orders',
        use_name: false,
        label: 'review_order',
        can: ['IU REVIEW ORDER VIEW']
      },
      {
        name: 'load_order',
        icon: 'TruckIcon',
        i18n: 'sidebar_load_order',
        url: '/load_orders',
        use_name: false,
        label: 'load_order',
        can: ['IU LOAD ORDER VIEW']
      },
      {
        name: 'discrepancy',
        icon: 'XOctagonIcon',
        i18n: 'sidebar_discrepancy',
        url: '/discrepancies',
        use_name: false,
        label: 'discrepancy',
        can: ['IU DISCREPANCY VIEW']
      }
    ]
  },
  {
    name: 'warehouse',
    icon: 'PackageIcon',
    i18n: 'warehouse',
    use_name: false,
    title: 'warehouse',
    label: 'warehouse',
    can: ['IU RANGES VIEW','IU PREEXPENSES VIEW'],
    submenu: [
      {
        name: 'clients',
        icon: 'UsersIcon',
        i18n: 'warehouse_clients',
        url: '/warehouse/client-price',
        use_name: false,
        label: 'warehouse_clients',
        can: ['IU RANGES VIEW'],
      },
      {
        name: 'expenses',
        icon: 'FileTextIcon',
        i18n: 'warehouse_expenses',
        url: '/warehouse/expense',
        use_name: false,
        label: 'warehouse_expenses',
        can: ['IU PREEXPENSES VIEW']
      }
    ]
  },
  {
    name: 'sidebar_human_resources',
    icon: 'CreditCardIcon',
    i18n: 'sidebar_human_resources',
    use_name: false,
    title: 'sidebar_human_resources',
    label: 'sidebar_human_resources',
    can: ['IU SALARY SURVEY VIEW', 'IU SALARY COMPARISON VIEW'],
    submenu: [
      {
        name: 'salary_survey',
        icon: 'UsersIcon',
        i18n: 'sidebar_salary_survey',
        url: '/salary_survey',
        use_name: false,
        label: 'salary_survey',
        can: ['IU SALARY SURVEY VIEW']
      },
      {
        name: 'salary_comparison',
        icon: 'MonitorIcon',
        i18n: 'sidebar_salary_comparison',
        url: '/salary_comparison',
        use_name: false,
        label: 'salary_comparison',
        can: ['IU SALARY COMPARISON VIEW']
      }
    ]
  },
  {
    name: 'sidebar_repse',
    icon: 'BookIcon',
    i18n: 'repse',
    use_name: false,
    title: 'repse',
    label: 'repse',
    can: ['IU Repse'],
    submenu: [
      {
        name: 'documents',
        icon: 'FileTextIcon',
        i18n: 'documents',
        url: '/repse/documents',
        use_name: false,
        label: 'documents',
        can: ['IU Repse']
      },
      {
        name: 'vendors',
        icon: 'TruckIcon',
        i18n: 'vendors',
        url: '/repse',
        use_name: false,
        label: 'vendors',
        can: ['IU Repse']
      }
    ]
  },
  {
    name: 'sidebar_budget',
    icon: 'DollarSignIcon',
    i18n: 'budget',
    use_name: false,
    title: 'budget',
    label: 'budget',
    can: ['IU BUDGET'],
    submenu: [
      {
        name: 'budget_category',
        icon: 'DollarSignIcon',
        i18n: 'budget_category',
        url: '/budget-category',
        use_name: false,
        label: 'budget_category',
        can: ['IU BUDGET']
      },
      {
        name: 'budget_departament',
        icon: 'DollarSignIcon',
        i18n: 'budget_departament',
        url: '/budget-departament',
        use_name: false,
        label: 'budget_departament',
        can: ['IU BUDGET']
      },
      {
        name: 'subtotals',
        icon: 'DollarSignIcon',
        i18n: 'subtotals',
        url: '/budget-subtotals',
        use_name: false,
        label: 'subtotals',
        can: ['IU BUDGET']
      },
      {
        name: 'departaments',
        icon: 'BookOpenIcon',
        i18n: 'departaments',
        url: '/budget/departament',
        use_name: false,
        label: 'departaments',
        can: ['IU BUDGET']
      },
      {
        name: 'assign',
        icon: 'ListIcon',
        i18n: 'assign',
        url: '/budget/assign',
        use_name: false,
        label: 'assign',
        can: ['IU BUDGET']
      }
    ]
  },
  {
    name: 'notifications',
    icon: 'MessageSquareIcon',
    i18n: 'notifications',
    use_name: false,
    title: 'notifications',
    label: 'notifications',
    can: ['IU RECRUITMENT NOTIFICATIONS'],
    submenu: [
      {
        name: 'Recruitment',
        icon: 'UserPlusIcon',
        i18n: 'recruitment',
        url: '/notifications/recruitment',
        use_name: false,
        label: 'recruitment',
        can: ['IU RECRUITMENT NOTIFICATIONS'],
      },
    ]
  },

  // {
  //   name: 'hsbc',
  //   icon: 'CreditCardIcon',
  //   i18n: 'hsbc',
  //   use_name: true,
  //   title: 'hsbc',
  //   label: 'hsbc',
  //   can: ['IU CLIENT VIEW'],
  //   url: '/hsbc'
  // },
  {
    name: 'po',
    icon: 'FileTextIcon',
    i18n: 'purchase_orders',
    use_name: true,
    title: 'purchase_orders',
    label: 'PO',
    can: ['IU PO'],
    url: '/purchase-orders'
  },
  {
    name: 'client',
    icon: 'UserIcon',
    i18n: 'clients',
    use_name: true,
    title: 'client',
    label: 'client',
    can: ['IU CLIENT VIEW'],
    url: '/clients'
  },
  {
    name: 'vendor',
    icon: 'UsersIcon',
    i18n: 'vendors',
    use_name: true,
    title: 'vendor',
    label: 'vendor',
    can: ['IU VENDORS VIEW'],
    url: '/vendors'
  },
  {
    name: 'Mail Server',
    icon: 'MailIcon',
    i18n: 'mail',
    use_name: true,
    title: 'mail_server',
    label: 'mail_server',
    can: ['IU MAIL SERVER VIEW'],
    url: '/mail_server'
  },
  {
    name: 'digizen',
    icon: 'CloudIcon',
    i18n: 'digizen',
    use_name: true,
    title: 'digizen',
    label: 'digizen',
    can: ['IU EHS VIEW',
      'IU EHS CATALOG VIEW',
      'IU COMPLIANCE VIEW',
      'IU CONTRALOR VIEW',
      'IU ACCOUNTING VIEW',
      'IU TAX RETURN VIEW',
      'IU BANK STATEMENT VIEW',
      'IU BLACKLIST VIEW',
      'IU CASH REQUEST VIEW',
      'IU ENTRY VIEW',
      'IU REVIEW ORDER VIEW',
      'IU LOAD ORDER VIEW',
      'IU DISCREPANCY VIEW',
      'IU CLIENT VIEW'],
    url: '/digizen'
  },
  // {
  //   name: 'digizen',
  //   icon: 'CloudIcon',
  //   i18n: 'digizen',
  //   use_name: true,
  //   title: 'digizen',
  //   label: 'digizen',
  //   can: ['IU CLIENT VIEW'],
  //   url: '/digizen'
  // }

  {
    name: 'quality',
    icon: 'GlobeIcon',
    i18n: 'quality',
    use_name: true,
    title: 'quality',
    label: 'quality',
    can: ['IU EHS VIEW',
      'IU EHS CATALOG VIEW',
      'IU COMPLIANCE VIEW',
      'IU CONTRALOR VIEW',
      'IU ACCOUNTING VIEW',
      'IU TAX RETURN VIEW',
      'IU BANK STATEMENT VIEW',
      'IU BLACKLIST VIEW',
      'IU CASH REQUEST VIEW',
      'IU ENTRY VIEW',
      'IU REVIEW ORDER VIEW',
      'IU LOAD ORDER VIEW',
      'IU DISCREPANCY VIEW',
      'IU CLIENT VIEW'],
    url: '/precisoft'
  },
  // {
  //   name: 'Test',
  //   icon: 'CodeIcon',
  //   i18n: 'Test',
  //   use_name: false,
  //   title: 'Test',
  //   label: 'Test',
  //   can: ['UI TEST'],
  //   submenu: [
  //    
  //     {
  //       name: 'warehouse-client-price',
  //       icon: 'BoxIcon',
  //       i18n: 'client_price',
  //       url: '/warehouse/client-price',
  //       use_name: false,
  //       label: 'client_price',
  //       can: ['UI TEST'],
  //     },
  //     {
  //       name: 'warehouse-expense',
  //       icon: 'FileTextIcon',
  //       i18n: 'expenses',
  //       url: '/warehouse/expense',
  //       use_name: false,
  //       label: 'expenses',
  //       can: ['UI TEST'],
  //     },
  //   ]
  // },
]
